<template>
  <div class="c-homepage__videos-carousel-wrapper">
    <!-- Selected Video -->
    <div class="c-homepage__videos-carousel-current c-homepage__videos-carousel-current--video" ref="selectedVideo">
      <div v-if="selectedVideo" :key="selectedVideo.ID" class="c-homepage__videos-selected-wrapper">
        <div class="c-homepage__videos-carousel-embed-container" :style="{ backgroundImage: 'url(' + selectedVideo.Thumbnail + ')' }">
          <iframe :src="getVideoEmbedURL(selectedVideo.VideoURL)" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <!-- Thumbnails -->
    <div class="c-homepage__videos-thumbnail-carousel">
      <div
        v-for="(video, index) in currentVideos"
        :key="video.ID"
        @click="selectVideo(index)"
        :class="['c-homepage__videos-thumb', { 'c-homepage__videos-thumb--active': selectedVideo === video }]"
      >
        <img :src="video.Thumbnail" alt="Thumbnail" class="c-homepage__videos-thumb-img" />
        <div class="c-homepage__videos-video-title">{{ video.Title }}</div>
      </div>
    </div>
    <!-- Selected Text -->
    <div class="c-homepage__videos-carousel-current c-homepage__videos-carousel-current--text">
      <div v-if="selectedVideo" class="c-homepage__videos-selected-wrapper">
        <h2>{{ selectedVideo.Title }}</h2>
        <p>{{ selectedVideo.Description }}</p>
        <template v-if="selectedVideo.Link && selectedVideo.Link.LinkURL">
          <a
            class="readmore readmore__linkBox"
            :href="selectedVideo.Link.LinkURL + (selectedVideo.Link.Anchor ? '#' + selectedVideo.Link.Anchor : '')"
            :target="selectedVideo.Link.OpenInNewWindow ? '_blank' : '_self'"
          >
            <p>{{ selectedVideo.Link.Title }}</p>
            <span></span>
          </a>
        </template>
      </div>
    </div>
    <!-- Next Button -->
    <div class="c-homepage__videos-carousel-controls" v-if="!isSmallScreen">
      <button
        class="c-homepage__videos-carousel-control c-homepage__videos-carousel--prev"
        :class="{ 'c-homepage__videos-carousel-control--disabled': disablePrev }"
        @click="prev()"
        :disabled="disablePrev"
      >
        <!-- SVG code for an up angle -->
        <svg class="c-homepage__videos-carousel-control-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M12 4.5l-8.5 8.5 1.41 1.41L12 7.83l7.09 7.08L20.5 13z"></path>
        </svg>
      </button>
      <button
        class="c-homepage__videos-carousel-control c-homepage__videos-carousel--next"
        :class="{ 'c-homepage__videos-carousel-control--disabled': disableNext }"
        @click="next()"
        :disabled="disableNext"
      >
        <!-- SVG code for a down angle -->
        <svg class="c-homepage__videos-carousel-control-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
          <path fill="currentColor" d="M12 19.5l8.5-8.5-1.41-1.41L12 16.17l-7.09-7.08L3.5 11z"></path>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      selectedVideo: null,
      currentPage: 0,
      videosPerPage: 4,
      isSmallScreen: window.innerWidth < 1200,
    };
  },
  computed: {
    ...mapState(["videos"]),
    currentVideos() {
      return this.isSmallScreen ? this.videos : this.videos.slice(this.currentPage * this.videosPerPage, (this.currentPage + 1) * this.videosPerPage);
    },
    disablePrev() {
      return this.currentPage === 0;
    },
    disableNext() {
      return this.videos.length <= this.videosPerPage || (this.currentPage + 1) * this.videosPerPage >= this.videos.length;
    },
  },
  methods: {
    getVideoEmbedURL(videoURL) {
      let videoID;

      if (videoURL.includes("youtube.com/embed")) {
        videoID = videoURL.split("embed/")[1];
      } else if (videoURL.includes("v=")) {
        videoID = videoURL.split("v=")[1];
      } else {
        videoID = videoURL;
      }

      return `https://www.youtube.com/embed/${videoID.split("?")[0].split("&")[0]}`;
    },
    selectVideo(index) {
      this.selectedVideo = this.currentVideos[index];
      this.$nextTick(() => {
        if (this.$refs.selectedVideo) {
          const rect = this.$refs.selectedVideo.getBoundingClientRect();
          const viewportHeight = window.innerHeight;
          const header = document.querySelector("header");
          const headerHeight = header ? header.offsetHeight : 0;
          const offset = headerHeight + 30;
          const topInView = rect.top >= headerHeight;
          const bottomInView = rect.top + rect.height <= viewportHeight;

          if (!topInView || !bottomInView) {
            const topPosition = rect.top + window.scrollY - offset;
            window.scrollTo({
              top: topPosition,
              behavior: "smooth",
            });
          }
        }
      });
    },
    next() {
      if ((this.currentPage + 1) * this.videosPerPage < this.videos.length) {
        this.currentPage++;
      }
    },
    prev() {
      if (this.currentPage > 0) {
        this.currentPage--;
      }
    },
    checkScreenWidth() {
      const screenWidth = window.innerWidth;
      this.isSmallScreen = screenWidth < 1366;
      this.videosPerPage = screenWidth >= 1920 ? 4 : 3;
    },
  },
  mounted() {
    this.selectedVideo = this.videos[0];
    window.addEventListener("resize", this.checkScreenWidth);
    this.checkScreenWidth();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenWidth);
  },
};
</script>
